import React from 'react'
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import {
    Body,
    SectionWrapper,
    NumberWrapper,
    Stage,
    Wrapper,
    NumberStyle,
    SliderWrapper,
    DynamicSliderWrap,
    SliderLabel
} from './styled'
import { 
    DialogPZBL
} from '../dialogs'
import rate1 from '../../assets/img/rate1.png'
import rate2 from '../../assets/img/rate2.png'
import rate3 from '../../assets/img/rate3.png'
import rate4 from '../../assets/img/rate4.png'
import rate5 from '../../assets/img/rate5.png'
import rate6 from '../../assets/img/rate6.png'
import rateIcon from '../../assets/img/rateIcon.png'
import sliderButtonImg from '../../assets/img/sliderButton.png'

class DynamicSlider extends React.Component {
    onSliderChange = (val) => {
        this.props.changeTotalPercent(val - this.props.value, this.props.index);
    }
    onAfterChange = (val) => {
    }
    render() {
        return (
            <SliderWrapper>
                <SliderLabel>
                    <div>
                        <img src={this.props.img} alt=""/>
                        <span>{this.props.label}</span>                        
                    </div>
                    <div>{this.props.value}%</div>
                </SliderLabel>
                <Slider
                    step={5}
                    value={this.props.value}
                    onChange={this.onSliderChange}
                    onAfterChange={this.onAfterChange}
                    trackStyle={{ backgroundColor: '#dfbf82', height: 5 }}
                    handleStyle={{
                        height: 30,
                        width: 30,
                        marginLeft: -10,
                        marginTop: -10,
                        borderColor: 'transparent',
                        background: `url(${sliderButtonImg})`,
                        backgroundSize: '100% 100%'
                    }}
                    railStyle={{ backgroundColor: '#2f333f', height: 5 }}></Slider>
            </SliderWrapper>
        )
    }
}

class RateWrapper extends React.Component {
    // 与components/MoneyConfig.js 逻辑相同，等有时间记得做复用
    constructor(props) {
        super(props)
        this.wrapperRotateFlag = []
        for (let i = 0; i < String(this.props.totalPercent).length; i++) {
            this.wrapperRotateFlag.push({
                index: Number(String(this.props.totalPercent)[i]),
                rotate: 0
            })
        }
    }
    rotateFlagUpdate = (item, index) => {
        let lastIndex = this.wrapperRotateFlag[index].index
        let lastRotate = this.wrapperRotateFlag[index].rotate
        let targeRotate;
        let abs
        let direct
        // 在一个循环中依据先后两数的大小，判断圆环旋转方向
        if (item >= lastIndex) {
            if (Math.abs(item - lastIndex) === Math.abs(lastIndex - item + 10)) {
                direct = true
                abs = Math.abs(item - lastIndex)
            } else if (Math.abs(item - lastIndex) < Math.abs(lastIndex - item + 10)) {
                direct = true
                abs = Math.abs(item - lastIndex)
            } else {
                direct = false
                abs = Math.abs(lastIndex - item + 10)
            }
        } else {
            if (Math.abs(item - lastIndex) === Math.abs(lastIndex - item + 10)) {
                direct = true
                abs = Math.abs(item - lastIndex)
            } else if (Math.abs(lastIndex - item) < Math.abs(item + 10 - lastIndex)) {
                direct = false
                abs = Math.abs(lastIndex - item)
            } else {
                direct = true
                abs = Math.abs(item + 10 - lastIndex)
            }
        }
        // let direct = item >=lastIndex 78901234567890123
        if (lastIndex === item) {
            if (lastRotate === 0) {
                targeRotate = item * (-36)
            } else {
                targeRotate = lastRotate
            }
        } else if (direct) {
            // 加
            targeRotate = lastRotate - abs * 36
        } else if (!direct) {
            // 减
            targeRotate = lastRotate + abs * 36
        }
        this.wrapperRotateFlag[index].index = item
        this.wrapperRotateFlag[index].rotate = targeRotate
        return targeRotate
    }
    render() {
        let numbersConfig = []
        String(this.props.totalPercent).split('').forEach(item => {
            let itemConfig = (() => {
                let arr = []
                for (let i = 0; i < 10; i++) {
                    arr.push({
                        label: i,
                        rotateX: 360 / 10 * i
                    })
                }
                return arr
            })()
            numbersConfig.push(itemConfig)
        })
        // 增减位判断保护，需优化
        if (String(this.props.totalPercent).length > this.wrapperRotateFlag.length) {
            for (let i = this.wrapperRotateFlag.length; i < String(this.props.totalPercent).length; i++) {
                this.wrapperRotateFlag.push({
                    index: Number(String(this.props.totalPercent)[i]),
                    rotate: 0
                })
            }
        }
        return (
            <NumberWrapper>
                {
                    // 不满100时加一个背景
                    String(this.props.totalPercent).split('').length < 3 && <Stage width={95}></Stage>
                }
                {
                    String(this.props.totalPercent).split('').map((item, index) => (
                        <Stage width={95} key={index}>
                            <Wrapper x={this.rotateFlagUpdate(Number(item), index)}>
                                {
                                    numbersConfig[index].map((t, index) => (
                                        <NumberStyle
                                            fontSize={80}
                                            key={index}
                                            x={t.rotateX}>{t.label}</NumberStyle>
                                    ))
                                }
                            </Wrapper>
                        </Stage>
                    ))
                }
                <Stage width={95}>
                    <span className='symbol'>%</span>
                </Stage>
            </NumberWrapper>
        )
    }
}

export default class RateConfig extends React.Component {
    constructor() {
        super()
        this.rateNumberWrapper = React.createRef();
        this.state = {
            totalPercent: 75,
            percent: [
                {
                    value: 25,
                    label: '上证企业债',
                    img: rate1
                },
                {
                    value: 10,
                    label: '原油',
                    img: rate2
                },
                {
                    value: 10,
                    label: '黄金',
                    img: rate3
                },
                {
                    value: 10,
                    label: '标普500',
                    img: rate4
                },
                {
                    value: 10,
                    label: '沪深300',
                    img: rate5
                },
                {
                    value: 10,
                    label: '中证500',
                    img: rate6
                },
            ],
            dialogState: {},
            fixed: false
        }
    }
    componentDidMount () {
        this.refTop = this.rateNumberWrapper.current.offsetTop
        window.addEventListener('scroll', this.scroll)
    }
    scroll = () => {
        if (this.refTop <= window.scrollY && !this.state.fixed) {
            this.setState(pre => ({
                fixed: true
            }))
        } else if (this.refTop > window.scrollY && this.state.fixed) {
            this.setState(pre => ({
                fixed: false
            }))
        }
    }
    changeTotalPercent = (val, index) => {
        this.setState(preState => {
            if (preState.totalPercent + val <= 100) {
                let last = preState.percent;
                last[index].value = last[index].value + val;
                return {
                    totalPercent: preState.totalPercent + val,
                    percent: last
                }
            }
        })
    }
    componentWillUnmount () {
        window.removeEventListener('scroll', this.scroll)
    }
    dialogCentre = (state, type) => {
        if (state) {
            switch (type) {
                case 'PZBL':
                    this.setState({
                        dialogState: {
                            PZBL: state
                        }
                    })
                    break;
                default:
                    break;
            }            
        } else {
            this.setState({
                dialogState: {}
            })
        }
    }
    render() {
        this.props.valueSubmit(this.state.percent);
        return (
            <Body>
                <SectionWrapper ref={this.rateNumberWrapper} fixed={this.state.fixed}>
                    <img onClick={this.dialogCentre.bind(this, true, 'PZBL')} className='icon' src={rateIcon} alt=""/>
                    <RateWrapper totalPercent={this.state.totalPercent}></RateWrapper>
                </SectionWrapper>
                <DynamicSliderWrap>
                    {
                        this.state.percent.map((item, index) => (
                            <DynamicSlider
                                key={index}
                                index={index}
                                label={item.label}
                                value={item.value}
                                img={item.img}
                                changeTotalPercent={this.changeTotalPercent}>
                                </DynamicSlider>
                        ))
                    }
                </DynamicSliderWrap>
                {
                    this.state.dialogState.PZBL && <DialogPZBL dialogCentre={this.dialogCentre}></DialogPZBL>
                }
            </Body>
        )
    }
}
